/** @format */
/** istanbul ignore file */

import { AemArticleData, AemDataService } from './aem-data.service';
import { Component, Input, OnInit } from '@angular/core';

import { Chain } from '@shared/data-access/interfaces';

@Component({
	selector: 'pdp-aem-articles',
	templateUrl: './aem-articles.component.html',
	styleUrl: './aem-articles.component.scss',
	standalone: false
})
export class AemArticlesComponent implements OnInit {
	@Input()
	article: string;

	/**
	 * @description
	 * The filename of the chain's logo image
	 *
	 * @type {string}
	 */
	public articleList: AemArticleData[] = [];
	public defaultImagery = {
		dsg: 'https://s7d6.scene7.com/is/image/DSGAEMSites/dsg-articles-default',
		gg: 'https://s7d6.scene7.com/is/image/DSGAEMSites/gg-articles-default',
		pl: 'https://s7d6.scene7.com/is/image/DSGAEMSites/pl-articles-default'
	};
	public imageIndexesWithError = new Set();

	constructor(
		private aemDataService: AemDataService,
		public chain: Chain
	) {}

	ngOnInit(): void {
		this.aemDataService.getArticles$(this.article).subscribe((res) => {
			if (res && res.root) {
				// slicing the list to only display the first 3 articles
				this.articleList = res.root[':items'].container[':items']['image_list'][
					'listItems'
				].slice(0, 3);
			}
		});
	}

	//  To-do: Need to add defaults for other brands once they support suggested articles on product pages
	public handleImageError(img: HTMLImageElement, index: number) {
		// Check if article has called this function already
		// Avoid infinite loop in the case default imagery also errors
		if (!this.imageIndexesWithError.has(index)) {
			// Add article index to the set
			this.imageIndexesWithError.add(index);

			// Replace article image with default imagery
			img.src = this.defaultImagery[this.chain.chainIdentifierAbbr];
		}
	}
}
